import React from 'react';
import { useQuery, useMutation, queryCache } from 'react-query';
import BernExpoTicket from '../components/BernExpoTicket';
import ParkingTicketBody from '../components/ParkingTicketBody';
import Header from '../components/ExternalPage/Header';
import DeviceStoreButtons from '../components/eTicket/DeviceStoreButtons';
import Loader from '../components/Loader';
import ErrorMessages from '../components/ErrorMessages';
import requsetErrorMessage from '../libraries/requsetErrorMessage';
import parkingSliderWindow from '../libraries/parkingSliderWindow';
import parkingFieldColor from '../libraries/parkingFieldColor';
import api from '../api';
import ErrorIcon from '../assets/images/icons/error.png';

/**
 * Owner parking eticket page — the logged-in user's OWN card, opened in a new
 * tab from the Parkkarten matrix. Mirrors the regular eTicket layout (big white
 * QR container + code below) but reads /parking/me (cookie-authenticated) and
 * picks the card by access_code_id, so it works for any card without a token.
 * @component
 */
export default ({ match }) => {
  const accessCodeId = Number(match.params.accessCodeId);
  const { data, error, isLoading } = useQuery('parking-me', api.parking.me);
  const ticket = (data?.data || []).find((c) => c.access_code_id === accessCodeId);

  // Mark used via slide-to-confirm (web equivalent of the mobile swipe), for
  // non-BernExpo fields without a gate scanner.
  const [markUsed, { isLoading: isMarking }] = useMutation(api.parking.use, {
    onSuccess() {
      queryCache.invalidateQueries('parking-me');
    },
  });

  const field = ticket?.field || {};
  const canConfirm =
    !!ticket && !ticket.used_at && !field.uses_external_qr && parkingSliderWindow(ticket.game_date);
  const mapsUrl =
    field.latitude != null && field.longitude != null
      ? `https://www.google.com/maps/search/?api=1&query=${field.latitude},${field.longitude}`
      : null;

  return (
    <div className="external-page">
      <Header />

      {!!error?.data?.message && (
        <center>
          <img src={ErrorIcon} alt="error" style={{ marginTop: 50, width: 60 }} />

          <ErrorMessages messages={requsetErrorMessage(error.data.message)} />
        </center>
      )}

      {isLoading ? (
        <Loader style={{ marginTop: 100 }} />
      ) : !ticket ? null : field.uses_external_qr ? (
        // BernExpo: distinct fully-digital QR design (no slider).
        <div className="ticket-view">
          <BernExpoTicket
            qrImage={ticket.qr_image}
            opponent={ticket.opponent}
            gameDate={ticket.game_date}
            usedAt={ticket.used_at}
          />

          <div
            className="no-print"
            style={{ display: 'flex', justifyContent: 'center', margin: '4px 0 10px' }}
          >
            <button
              onClick={() => window.print()}
              style={{
                background: '#e73c37',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                padding: '10px 24px',
                fontSize: 15,
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              Parkkarte drucken
            </button>
          </div>

          <h3
            className="no-print"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <DeviceStoreButtons />
          </h3>
        </div>
      ) : (
        <div className="ticket-view">
          <ParkingTicketBody
            qrImage={ticket.qr_image}
            qrPayload={ticket.qr_payload}
            usedAt={ticket.used_at}
            color={parkingFieldColor(field.slug)}
            fieldName={field.name}
            entrance={field.entrance}
            mapsUrl={mapsUrl}
            infoText={field.info_text}
            opponent={ticket.opponent}
            gameDate={ticket.game_date}
            location="PostFinance Arena"
            canConfirm={canConfirm}
            confirming={isMarking}
            onConfirm={() => markUsed(accessCodeId)}
          />

          <h3
            className="no-print"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <DeviceStoreButtons />
          </h3>
        </div>
      )}
    </div>
  );
};
